import React, { useEffect, useState } from "react";
import { adminListTranslations } from "../../lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState({ translations: 0 });

  useEffect(() => {
    (async () => {
      try {
        const tr = await adminListTranslations();
        setStats({ translations: tr.length });
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const Card = ({ label, value, testid }) => (
    <div className="admin-card" style={{ flex: 1, minWidth: 200 }} data-testid={testid}>
      <div style={{ fontSize: 12, color: "#7a5a20", letterSpacing: 1, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: 40, color: "#4a0000", fontWeight: 900, marginTop: 8 }}>{value}</div>
    </div>
  );

  return (
    <div data-testid="admin-dashboard">
      <div className="admin-heading">Dashboard</div>
      <div className="admin-sub">Overview of site content.</div>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <Card label="Translations" value={stats.translations} testid="stat-translations" />
      </div>
    </div>
  );
}
